import React from 'react'

interface AlertProps {
  type?: 'success' | 'error' | 'warning' | 'info'
  dismissible?: boolean
  onDismiss?: () => void
  children: React.ReactNode
  header?: string
  statusIconAriaLabel?: string
  action?: React.ReactNode
}

export const Alert: React.FC<AlertProps> = ({ type = 'info', dismissible, onDismiss, children, header }) => {
  const colors = {
    success: { bg: '#d4edda', border: '#28a745', text: '#155724', icon: '✓' },
    error: { bg: '#fff5f5', border: '#db0000', text: '#721c24', icon: '✕' },
    warning: { bg: '#fffef0', border: '#855900', text: '#856404', icon: '⚠' },
    info: { bg: '#f0fbff', border: '#006ce0', text: '#0c5460', icon: 'i' },
  }

  const style = colors[type]

  return (
    <div
      style={{
        backgroundColor: style.bg,
        border: `2px solid ${style.border}`,
        color: style.text,
        padding: '12px 16px',
        borderRadius: '12px',
        marginBottom: '16px',
        position: 'relative',
        display: 'flex',
        gap: '12px',
        alignItems: 'center',
      }}
    >
      <div
        style={{
          width: '20px',
          height: '20px',
          borderRadius: '50%',
          border: `2px solid ${style.border}`,
          color: style.border,
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          fontSize: '12px',
          fontWeight: 'bold',
          flexShrink: 0,
        }}
      >
        {style.icon}
      </div>
      <div style={{ flex: 1 }}>
        {header && <div style={{ fontWeight: 'bold', marginBottom: '4px' }}>{header}</div>}
        <div>{children}</div>
      </div>
      {dismissible && (
        <button
          onClick={onDismiss}
          style={{
            background: 'none',
            border: 'none',
            fontSize: '20px',
            cursor: 'pointer',
            color: style.text,
            padding: '0 4px',
            flexShrink: 0,
            lineHeight: 1,
          }}
        >
          ×
        </button>
      )}
    </div>
  )
}
